import styles from "./day.module.css";
import Acardeon from "./acardeon/Acardeon";
import AcardeonMian from "./acardeon/AcardeonMian";
import AcarderonEghamat from "./acardeon/acardeonEghamat";
import AcardeonTransfer from "./acardeon/AcardeonTransfer";
import AcardeonGashtha from "./acardeon/AcardeonGashtha";
import { useState } from "react";
import { useMeals, useMealsAction } from "../../../Context/MealsProvider";
import { FaEye } from "react-icons/fa";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";

const MealList = ({ dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();

  const statusChanger = (id) => {
    dispatch({
      type: "changeHandlerPublic",
      day: dayIndex,
      mealId: id,
    });
  };

  return (
    <div className={styles.containerMeal}>
      {meals[dayIndex].map((meal, index) => {
        return (
          meal.status &&
          (meal.id == 8 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][8].isPublic && styles.black}`} onClick={() => statusChanger(8)} />

              <p className={styles.titlepText}>{meal.title}</p>

              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />

              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <Acardeon index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 6 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(6)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcarderonEghamat index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 0 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(0)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonGashtha index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 4 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(4)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonGashtha index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 7 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(7)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonGashtha index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 3 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(3)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonMian index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 5 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(5)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonTransfer index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : meal.id == 1 ? (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(1)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonTransfer index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ) : (
            <div className={styles.mealRow}>
              <FaEye className={`${styles.mealEye} ${meals[dayIndex][index].isPublic && styles.black}`} onClick={() => statusChanger(2)} />

              <p className={styles.titlepText}>{meal.title}</p>
              <input
                type="text"
                className={styles.inputBoxs}
                value={addCommas(meals[dayIndex][index].price)}
                onChange={(e) =>
                  dispatch({
                    type: "changeHandler",
                    day: dayIndex,
                    id: index,
                    event: e,
                  })
                }
              />
              <div className={styles.priceOtherBox}>
                <div className={styles.acaardeon}>
                  <AcardeonTransfer index={index} dayIndex={dayIndex} />
                </div>
              </div>
            </div>
          ))
        );
      })}
    </div>
  );
};

export default MealList;
